exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".confirmation-popup{width:25%}@media(max-width:1024px){.confirmation-popup{width:60%}}@media(max-width:767px){.confirmation-popup{width:100%;max-height:30%}}.confirmation-popup__title{text-align:center}.confirmation-popup__body{margin-top:20px;display:flex;justify-content:center}.confirmation-popup__body button{margin:0 10px}", ""]);

